import { render } from "./Footer.vue?vue&type=template&id=397ce40f&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=397ce40f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-397ce40f"

export default script